if (!customElements.get("page-list")) {
	class CollectionList extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.selectors = {
				sliderWrapper: ".page-list__items",
				pagination: ".swiper-pagination",
				nextEl: ".swiper-btn-next",
				prevEl: ".swiper-btn-prev",
			};
			this.classes = {
				grid: "f-grid",
				swiper: "swiper",
				swiperWrapper: "swiper-wrapper",
			};

			this.sectionId = this.dataset.sectionId;
			this.section = this.closest(`.section-${this.sectionId}`);
			this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

			this.enableSlider = this.dataset.enableSlider === "true";
			this.items = parseInt(this.dataset.items);
			this.tabletItems = parseInt(this.dataset.tabletItems);

			this.sliderInstance = false;

			if (!this.enableSlider) return;

			this.init();
			document.addEventListener("matchMobile", () => {
				this.init();
			});
			document.addEventListener("unmatchMobile", () => {
				this.init();
			});
		}

		init() {
			if (FoxTheme.config.mqlMobile && this.dataset.enableSwipeMobile !== "true") {
				this.destroySlider();
			} else {
				this.initSlider();
			}
		}

		initSlider() {
			const containerWidth = this.sliderWrapper.clientWidth;
			let slidesOffsetAfterValue = 0;

			if (window.innerWidth >= 1280) {
				slidesOffsetAfterValue = containerWidth * 0.35;
				slidesOffsetAfterValue = Math.min(slidesOffsetAfterValue - 100, 900);
			}
			const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue("--column-gap");
			const spaceBetween = parseFloat(columnGap.replace("rem", "")) * 10;

			const sliderOptions = {
				slidesPerView: parseInt(this.tabletItems),
				spaceBetween: spaceBetween,
				slidesOffsetAfter: slidesOffsetAfterValue,
				slidesPerGroup: 1,
				navigation: {
					nextEl: this.section.querySelector(this.selectors.nextEl),
					prevEl: this.section.querySelector(this.selectors.prevEl),
				},
				pagination: false,
				breakpoints: {
					1280: {
						slidesPerView: parseInt(this.items),
					},
				},
				loop: false,
				threshold: 2,
			};

			if (typeof this.sliderInstance !== "object") {
				this.classList.add(this.classes.swiper);
				this.sliderWrapper.classList.remove(this.classes.grid);
				this.sliderWrapper.classList.add(this.classes.swiperWrapper);
				this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
				this.sliderInstance.init();

				// On load
				if (this.sliderInstance.slider.isBeginning) {
					this.section.querySelector(this.selectors.prevEl)?.classList.add("btn-hidden");
				}
				if (this.sliderInstance.slider.isEnd) {
					this.section.querySelector(this.selectors.nextEl)?.classList.add("btn-hidden");
				}

				// Handle slider events
				this.sliderInstance.slider.on("reachEnd", () => {
					this.section.querySelector(this.selectors.nextEl)?.classList.add("btn-hidden");
				});
				this.sliderInstance.slider.on("fromEdge", () => {
					this.section.querySelector(this.selectors.nextEl)?.classList.remove("btn-hidden");
				});
				this.sliderInstance.slider.on("reachBeginning", () => {
					this.section.querySelector(this.selectors.prevEl)?.classList.add("btn-hidden");
				});
				this.sliderInstance.slider.on("fromEdge", () => {
					this.section.querySelector(this.selectors.prevEl)?.classList.remove("btn-hidden");
				});

				const focusableElements = FoxTheme.a11y.getFocusableElements(this);

				focusableElements.forEach((element) => {
					element.addEventListener("focusin", () => {
						const slide = element.closest(".swiper-slide");
						this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
					});
				});
			}

			if (Shopify.designMode && typeof this.sliderInstance === "object") {
				document.addEventListener("shopify:block:select", (e) => {
					if (e.detail.sectionId != this.sectionId) return;
					let { target } = e;
					const index = Number(target.dataset.index);

					this.sliderInstance.slider.slideToLoop(index);
				});
			}
		}

		destroySlider() {
			this.classList.remove(this.classes.swiper);
			this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
			this.sliderWrapper.classList.add(this.classes.grid);
			if (typeof this.sliderInstance === "object") {
				this.sliderInstance.slider.destroy();
				this.sliderInstance = false;
			}
		}
	}
	customElements.define("page-list", CollectionList);
}
